import React               from 'react';
import { Link }            from 'react-router-dom';
import { isNotEmptyArray } from 'ts-data-validator';

import needReset      from '../../../../common/tools/need-reset';
import { useCatalog } from '../../../../providers/catalog';

const CityButton = function(props) {
  const {label, link} = props;

  const {
          resetFilter,
          getCatalogItems,
        } = useCatalog();

  const formattedLink = React.useMemo(() => {
    return link.startsWith('/') ? link : `/${link}`;
  }, [link]);

  const handleClick = () => {
    if (needReset(formattedLink)) {
      resetFilter();
      getCatalogItems(formattedLink);
    }
  };

  return (
    <Link
      className={'city_item'}
      onClick={handleClick}
      to={formattedLink}
    >{label}</Link>
  );
}

const renderCitiesBlock = function(data, index) {
  const { CONTENT } = data;

  return (
    <section
      className={'cities_container'}
      key={index}
    >
      <div className={'container'}>
        {isNotEmptyArray(CONTENT) && (
          <div className={'cities_wrapper'}>
            {CONTENT.map((city, index) => {
              if (!city) {
                return null;
              }

              return (
                <CityButton
                  key={index}
                  label={city.LABEL}
                  link={city.LINK}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default renderCitiesBlock;